import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AdDirective } from './ad.directive';
import { PopoverProperties } from './interfaces';
import { OverlayModule } from './overlay/overlay.module';
import { PopoverElementDirective } from './popover-element.directive';
import { PopoverPropertiesService } from './popover-properties.service';
import { PopoverTriggerDirective } from './popover-trigger.directive';
import { PopoverComponent } from './popover.component';
import { Popover } from './popover.service';

@NgModule({
  declarations: [PopoverComponent, AdDirective, PopoverElementDirective, PopoverTriggerDirective],
  imports: [CommonModule, OverlayModule],
  exports: [PopoverElementDirective, PopoverTriggerDirective],
  providers: [Popover],
  bootstrap: [],
})
export class PopoverModule {
  static forRoot(initProperties: PopoverProperties): ModuleWithProviders<PopoverModule> {
    return {
      ngModule: PopoverModule,
      providers: [
        {
          provide: PopoverPropertiesService,
          useValue: initProperties,
        },
      ],
    };
  }
}
